import styled from 'styled-components';

const BrandCardContent = styled.div``;

export default BrandCardContent;
